// Inertia replaces history state when caching pages. Keep a private position
// alongside that state, without adding entries or changing its page payload.
const key = '__workflowNavigationPosition'
let installed = false, activeGuard = null
export function installNavigationPositions() {
  if (installed || typeof window === 'undefined') return
  installed = true
  // Window is the popstate target. Register before Inertia, rather than relying
  // on capture ordering after its asynchronous history restore has started.
  window.addEventListener('popstate', (event) => activeGuard?.(event), true)
  const push = window.history.pushState.bind(window.history)
  const replace = window.history.replaceState.bind(window.history)
  replace({ ...window.history.state, [key]: Number.isInteger(window.history.state?.[key]) ? window.history.state[key] : 0 }, '')
  window.history.pushState = (state, title, url) => push({ ...state, [key]: (window.history.state?.[key] ?? 0) + 1 }, title, url)
  window.history.replaceState = (state, title, url) => replace({ ...state, [key]: window.history.state?.[key] ?? 0 }, title, url)
}
export function guardHistoryNavigation(shouldHold, onAttempt) {
  let position = window.history.state?.[key], restoring = null
  const originalState = window.history.state, originalUrl = window.location.href
  function pop(event) {
    const target = event.state?.[key]
    if (restoring !== null) {
      event.stopImmediatePropagation()
      if (target === position) { const destination = restoring; restoring = null; onAttempt(destination) }
      else if (Number.isInteger(target)) window.history.go(position - target)
      return
    }
    if (!Number.isInteger(target) && shouldHold()) {
      event.stopImmediatePropagation()
      const url = window.location.href
      // A legacy same-document entry has no usable delta. Preserve the draft
      // and restore its address before offering an explicit ordinary visit.
      window.history.pushState(originalState, '', originalUrl)
      position = window.history.state[key]
      onAttempt({ url })
      return
    }
    if (Number.isInteger(position) && Number.isInteger(target) && target !== position && shouldHold()) {
      event.stopImmediatePropagation()
      const delta = target - position
      restoring = { delta }
      window.history.go(-delta)
    } else position = target
  }
  activeGuard = pop
  return () => { if (activeGuard === pop) activeGuard = null }
}
